// IE 11 and Edge 18 do not support Array.prototype.flatMap()
export const flatMap = (array, callback) => {
  return array.reduce((accumulator, item) => {
    return accumulator.concat(callback(item));
  }, []);
};
